import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const TargetedAudience = ({ onTargetedAudienceSelected }) => {
  const [selectedTargetedAudience, setSelectedTargetedAudience] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.targetedaudience) {
        const targetedAudienceObject = firstResult.targetedaudience;
        if (targetedAudienceObject.trim() !== "") {
          setVariations(targetedAudienceObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleTargetedAudienceClick = (targetedaudience) => {
    setSelectedTargetedAudience(targetedaudience);
    onTargetedAudienceSelected(targetedaudience);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Targeted Audience:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedTargetedAudience === variation ? "selected" : ""}`}
            onClick={() => handleTargetedAudienceClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default TargetedAudience;
